import React, { Component } from 'react';
import Spinner from './Spinner';
import axios from 'axios';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';

let cache = {};

class Widget extends Component {
  constructor(props) {
    super(props);
    this.resolveTemplateVariableInQueryDebounce = debounce(this.resolveTemplateVariableInQuery, 2000);
  }

  state = {
    loading: false
  };

  loadData(query) {
    if (!this.props.repoURL) return console.log('Repo URL is not set!');

    if (query) {
      // default use proxy server

      let url = '/api/sparql/' + this.props.repoURL;
      let encodedQuery = encodeURIComponent(query);
      let data = {
        query: encodedQuery
      };
      let headers = {
        Authorization: `Bearer ${localStorage.getItem('kvk-vb-token')}`
      };
      if (this.props.repoURL.startsWith('http')) {
        // request sparql endpoint directly
        url = this.props.repoURL;
        data = 'infer=false&sameAs=false&query=' + encodedQuery;
        headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/sparql-results+json'
        };
      }

      this.setState({
        loading: true,
        message: null
      });
      

      //console.log(query);
        if (true)
        {
          

          
      let results = cache[encodedQuery];
      if (results) {
        this.setState({
          data: results,
          loading: false,
          cachedResults:true
         
        });
         console.log('using cache results ');
        return;
      }
    }

     

      // retreive data from sparql endpoint
      //  console.log("using triplestore results ");
      axios({
        method: 'post',
        url,
        data,
        headers
      })
        .then(response => {
          cache[encodedQuery] = response.data;
          this.setState({
            data: response.data,
            loading: false
          });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }

  resolveTemplateVariableInQuery = changedPublishProp => {
    let query = this.props.query;
    if (!query) return;

    const regex = /{{\S*}}/g;
    let subscribeProps = query.match(regex);
    if (!subscribeProps) {
      if (changedPublishProp) return;
      return this.loadData(query);
    }

    subscribeProps = subscribeProps.map(f => f.replace(/[{}]/g, ''));
    subscribeProps = [...new Set(subscribeProps)]; // remove duplicates

    if (changedPublishProp && !subscribeProps.includes(changedPublishProp)) {
      return;
    }

    for (var i = 0; i < subscribeProps.length; i++) {
      let subscribeProp = subscribeProps[i];
      let subscribeValue = this.props.pubsub[subscribeProp];

      if (!subscribeValue) {
        return this.setState({
          //message: `Kies een ${subscribeProp}`
          message: ''
        });
      }

      let regex2 = new RegExp(`{{${subscribeProp}}}`, 'g');
      query = query.replace(regex2, subscribeValue);
    }

    this.loadData(query);
  };

  componentDidMount() {
    let variables = this.props.definition.variables;
    let queryDefinition = variables && variables.find(variable => variable.name === 'query');
    if (!queryDefinition) return;
    if (this.props.withinSelectedTab === false) return;
    this.resolveTemplateVariableInQuery();
  }

  componentDidUpdate(prevProps) {
    let variables = this.props.definition.variables;
    let queryDefinition = variables && variables.find(variable => variable.name === 'query');
    if (!queryDefinition) return;

    if (prevProps.repoURL !== this.props.repoURL) {
      this.resolveTemplateVariableInQueryDebounce();
    } else if (this.props.withinSelectedTab !== prevProps.withinSelectedTab) {
      // if (this.props.withinSelectedTab && !this.state.data){
      if (this.props.withinSelectedTab) {
        this.resolveTemplateVariableInQuery();
      }
    } else if (prevProps.query !== this.props.query) {
      this.resolveTemplateVariableInQuery();
    } else if (!isEqual(prevProps.pubsub, this.props.pubsub)) {
      let changedPublishProp;

      Object.keys(this.props.pubsub).forEach(key => {
        if (prevProps.pubsub[key] !== this.props.pubsub[key]) {
          changedPublishProp = key;
        }
      });

      this.resolveTemplateVariableInQuery(changedPublishProp);
    }
  }

  publish = (prop, value) => {
    this.props.dispatch({
      type: 'PUBLISH',
      data: {
        [prop]: value
      }
    });
  };

  render() {
    if (this.state.loading) return <Spinner />;
    if (this.state.message) return <div>{this.state.message}</div>;

    return React.cloneElement(this.props.children, {
      ...this.state,
      ...this.props,
      publish: this.publish
    });
  }
}
const mapStateToProps = state => ({
  pubsub: state.pubsub
});

export default connect(mapStateToProps)(Widget);
//export default Widget;
